<template>
    <h2
        :class="
            twMerge(
                'whitespace-pre-line text-center text-[2.5rem] font-bold leading-[1.3] lg:text-[4rem]',
                locale === 'ja' && '',
                locale === 'ko' && '',
                (locale === 'en' || lang === 'en') &&
                    'font-en leading-[1.2] lg:tracking-[-0.02em]',
                $attrs.class,
            )
        "
    >
        <slot />
    </h2>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
const { lang = "tw" } = defineProps({ lang: { type: String, default: "tw" } });

const { locale } = useI18n();
</script>
